type StatusObject = {
  [key: string]: {
    text: string
    color: string
  }
}

export const STATUS_OBJECT: StatusObject = {
  IDENTIFIED: {
    text: 'Identificado',
    color: 'red',
  },
  DELETED: {
    text: 'Deletado',
    color: 'red',
  },
  ATTENDING: {
    text: 'Em atendimento',
    color: 'blue',
  },
  OPEN: {
    text: 'Em aberto',
    color: 'orange',
  },
  INVESTIGATING: {
    text: 'Em atendimento',
    color: 'purple',
  },
  CONCLUDED: {
    text: 'Concluído',
    color: 'green',
  },
  INCONCLUSIVE: {
    text: 'Inconclusivo',
    color: 'blue',
  },
  'AUTO-CONCLUDED': {
    text: 'Conclusão automática',
    color: 'green',
  },
  'FALSE-POSITIVE': {
    text: 'Falso positivo',
    color: 'gray',
  },
  'AUTO-FALSE-POSITIVE': {
    text: 'Falso positivo automático',
    color: 'gray',
  },
  ACTIVE: {
    text: 'Ativo',
    color: 'green',
  },
  INACTIVE: {
    text: 'Inativo',
    color: 'red',
  },
  WAITING: {
    text: 'Pendente',
    color: 'orange',
  },
  PENDING: {
    text: 'Pendente',
    color: 'orange',
  },
  ACCEPTED: {
    text: 'Aprovada',
    color: 'green',
  },
  REJECTED: {
    text: 'Rejeitada',
    color: 'red',
  },
  DECLINED: {
    text: 'Recusada',
    color: 'red',
  },
  CANCELLED: {
    text: 'Cancelado',
    color: 'red',
  },
  REVOKED: {
    text: 'Revogada',
    color: 'red',
  },
  GONE: {
    text: 'Extinto',
    color: 'red',
  },
  UNKNOWN: {
    text: 'Desconhecido',
    color: 'borderColor',
  },
}
